<template>
    <section>
        <div
            v-if="isVideoUploaded"
            class="VideoBanner"
            :class="{ 'is-playing' : playClicked }"
        >
            <video
                id="video"
                width="320"
                height="240"
                controls
            >
                <source
                    :src="data"
                    type="video/mp4"
                >
            </video>

            <div
                class="VideoBanner__container lazyload"
                :data-bgset="srcset"
            >
                <div class="container">
                    <BaseHeading
                        :preheading="preheading"
                        :heading="heading"
                        tag="h1"
                        class="text--white"
                    />
                    <button
                        class="VideoBanner__play"
                        @click="playVideo"
                    >
                        <BaseIcon
                            icon="play-icon"
                            color="white"
                        />
                    </button>
                </div>
            </div>
        </div>
        <BaseVideo
            v-else
            :data="data"
            :type="type"
            :data-bgset="srcset"
        >
            <BaseHeading
                :preheading="preheading"
                :heading="heading"
                tag="h1"
                class="text--white"
            />
        </BaseVideo>
    </section>
</template>

<script>
export default {
    name: 'BannerVideo',
    props: {
        data: {
            type: String,
            required: true
        },
        preheading: {
            type: String,
            default: null
        },
        heading: {
            type: String,
            default: null
        },
        type: {
            type: String,
            required: true
        },
        srcset: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            playClicked: false,
        }
    },
    computed: {
        isVideoUploaded() {
            return this.type === 'mp4';
        },
    },

    methods: {
        playVideo() {
            const video = document.getElementById('video')
            this.playClicked = true
            video.play()
        }
    }
}
</script>

<style lang="scss" scoped>

    .VideoBanner {
        position: relative;
        height: 380px;

        @include media-query(portable) {
            margin-bottom: calc(380px / 2);
        }

        @include media-query(lap-and-up) {
            height: 700px;
        }
    }

    .VideoBanner__container {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-size: cover;
        opacity: 1;
        transition: all ease-out 0.65s;

        &:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: rgba(getColor('black'), 0.45);
        }

        .is-playing & {
            opacity: 0;
            pointer-events: none;
        }
    }

    video {
        width: 100%;
        height: auto;
        z-index: 1;
    }

    .BaseHeading {
        text-align: center;
        max-width: 500px;
        position: relative;
        margin-bottom: getSpacing(medium);
    }

    .VideoBanner__play {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        margin: auto;
        cursor: pointer;
        background: $action-color;
        border: 2px solid getColor('white');
        border-radius: 50%;
        transition: all ease-out 0.345s;
        position: relative;

        &:hover {
            background: getColor('blue', 'charcoal');
        }

        @include media-query(lap-and-up) {
            width: 80px;
            height: 80px;
        }

        .BaseIcon {
            position: relative;
            left: 0.25rem;
            font-size: 2rem;
        }
    }

    ::v-deep .BaseVideo {
        padding-bottom: 56.5%;
    }

    ::v-deep .BaseVideo__play {
        flex-direction: column;
    }
</style>
